import { MessageType } from '@tencent/dz-models';
import { withType } from '../../../hoc';
import Component from './SystemMessage';
// 组件实例
var BlockSystemMessage = withType(Component);
BlockSystemMessage.msgType = MessageType.SystemCustom || MessageType.SystemBye;
var BlockSystemBye = withType(Component);
BlockSystemBye.msgType = MessageType.SystemBye;
var BlockSystemHistory = withType(Component);
BlockSystemHistory.msgType = MessageType.SystemHistory;
export { BlockSystemMessage, BlockSystemBye, BlockSystemHistory };
